(() => {
  const initialize = (root) => {
    if (root.dataset.contextReady) return;
    root.dataset.contextReady = 'true';
    const query = new URLSearchParams(window.location.search);
    const plain = (value, limit = 250) => String(value || '').replace(/[\u0000-\u001f\u007f]/g, '').slice(0, limit).trim();
    const title = plain(query.get('product_title'));
    const path = plain(query.get('product_url'), 500);
    if (!title || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-zA-Z0-9-]+\/?$/i.test(path)) return;
    const url = new URL(path, window.location.origin);
    const variant = query.get('variant') || '';
    if (/^\d{1,30}$/.test(variant)) url.searchParams.set('variant', variant);
    const options = ['option_1', 'option_2', 'option_3'].map((name) => plain(query.get(name))).filter(Boolean);
    const variantTitle = plain(query.get('variant_title'));
    if (!options.length && variantTitle && variantTitle !== 'Default Title') options.push(variantTitle);
    const lines = [`${root.dataset.productLabel}: ${title}`];
    if (options.length) lines.push(`${root.dataset.optionsLabel}: ${options.join(' / ')}`);
    lines.push(`${root.dataset.linkLabel}: ${url.href}`);
    const summary = root.querySelector('[data-quote-context-summary]');
    const status = root.querySelector('[data-quote-context-status]');
    const back = root.querySelector('[data-quote-context-back]');
    summary.value = lines.join('\n');
    back.href = url.href;
    root.hidden = false;
    root.querySelector('[data-copy-quote-context]').addEventListener('click', async () => {
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(summary.value);
        status.textContent = root.dataset.copied;
      } catch {
        summary.focus();
        summary.select();
        status.textContent = root.dataset.copyFailed;
      }
    });
  };
  const scan = (scope = document) => {
    if (scope.matches?.('[data-quote-context]')) initialize(scope);
    scope.querySelectorAll('[data-quote-context]').forEach(initialize);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan());
  else scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
